import type { GeminiVoiceId, ProjectAudioConfig } from '../shared/voices';

export function setCharacterVoice(
  config: ProjectAudioConfig,
  previousName: string | undefined,
  nextName: string,
  voice: GeminiVoiceId,
): ProjectAudioConfig {
  const characters = { ...config.characters };
  if (previousName && previousName !== nextName) delete characters[previousName];
  characters[nextName] = voice;
  return { ...config, characters };
}

export function removeCharacterVoice(config: ProjectAudioConfig, characterName: string): ProjectAudioConfig {
  const characters = { ...config.characters };
  delete characters[characterName];
  return { ...config, characters };
}
